module.exports = __webpack_public_path__ + "img/base.3425ce14.svg";